import { PiChatText } from 'react-icons/pi';

export const SearchEmpty = () => (
  <div className="bg-base-80 text-base-30 h-screen flex flex-col items-center justify-center gap-4">
    <PiChatText size={40} />
    <p className="text-m-r">No chats found</p>
  </div>
);
